import PageTypeUnderConstruct from "../components/PageTypeUnderConstruct/PageTypeUnderConstruct";
import { pagesDataA } from "../data/pagesData";

const Page0 = () => {
  return (
    <PageTypeUnderConstruct title={pagesDataA[0].title} subtitle={pagesDataA[0].subtitle} image={pagesDataA[0].image} />
  );
};

export default Page0;
